import React from 'react';
import HomeHeroAuthentication from '@/pages/home/hero/HomeHeroAuthentication';

const HomeHeroContentPublicThailand = (): JSX.Element => {
  return <HomeHeroAuthentication />;
};

export default HomeHeroContentPublicThailand;
